export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20dark%20forest%20green%20geometric%20pattern%20with%20flowing%20organic%20lines%2C%20layered%20translucent%20shapes%20in%20deep%20emerald%20and%20sage%20tones%2C%20modern%20minimalist%20corporate%20background%20with%20soft%20gradient%20transitions%2C%20clean%20elegant%20atmosphere%2C%20no%20text%2C%20smooth%20textures%2C%20subtle%20depth&width=1800&height=600&seq=hero-bg-fs-2026&orientation=landscape"
          alt="Tianyi 文件系统背景"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 md:px-6">
        <div className="w-full max-w-4xl text-center animate-fade-in">
          <h2 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-background-50 leading-tight tracking-tight animate-fade-in-up" style={{ animationDelay: '0.1s' }}>
            让文件管理
            <br />
            回归<span className="italic">简单</span>与<span className="italic">高效</span>
          </h2>
          <p className="mt-6 md:mt-8 text-background-50/75 text-sm md:text-base max-w-xl mx-auto leading-relaxed animate-fade-in-up" style={{ animationDelay: '0.25s' }}>
            Tianyi 文件系统，为企业团队打造安全可靠的云端文件存储与协作平台，
            智能分类、版本管理、权限控制一应俱全。
          </p>
          <div className="mt-8 md:mt-10 flex flex-col sm:flex-row items-center justify-center gap-3 animate-fade-in-up" style={{ animationDelay: '0.4s' }}>
            <a
              href="#pricing"
              className="px-8 py-3 rounded-full bg-primary-500/90 text-background-50 text-sm font-medium hover:bg-primary-500 transition-all whitespace-nowrap cursor-pointer backdrop-blur-sm"
            >
              立即体验
            </a>
            <a
              href="#functions"
              className="px-8 py-3 rounded-full border border-background-50/40 text-background-50 text-sm font-medium hover:bg-background-50/10 transition-all whitespace-nowrap cursor-pointer"
            >
              了解更多
            </a>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 w-full pb-8 md:pb-12 flex justify-center">
        <p className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-background-50/15 tracking-wider select-none whitespace-nowrap">
          云端文件协作新纪元
        </p>
      </div>
    </section>
  );
}